import module from 'finanzas/module.js'
import template from './template.html'

function FinancesPosicionbancariaPrestamoDocumentosAgregarComponent (FinancesPosicionbancariaPrestamoDocumentos) {
  var $ctrl = this

  $ctrl.aceptar = aceptar
  $ctrl.archivo = undefined
  $ctrl.cerrar = cerrar

  function aceptar () {
    let data = new FormData()
    data.append('documento', $ctrl.archivo)

    $ctrl.procesando = true

    FinancesPosicionbancariaPrestamoDocumentos.post($ctrl.idEmpresa, $ctrl.idCuenta, $ctrl.idPrestamo, data)
      .then(function (response) {
        cerrar(response.data)
      })
      .finally(function () {
        $ctrl.procesando = false
      })
  }

  function cerrar (data) {
    $ctrl.onClose({$event: {data: data}})
  }
}

module.component('financesPosicionbancariaPrestamoDocumentosAgregar', {
  controller: FinancesPosicionbancariaPrestamoDocumentosAgregarComponent,
  template,
  bindings: {
    idEmpresa: '<',
    idCuenta: '<',
    idPrestamo: '<',
    data: '<',
    onClose: '&',
  },
})



// WEBPACK FOOTER //
// ./src/finanzas/components/posicionbancaria/prestamo/documentos/agregar/component.js